import toDate from '../to-date';

export const getYear = (date: Date | number): number => {
  const formattedDate = toDate(date);
  const year = formattedDate.getFullYear();

  return year;
};

export default getYear;
